module.exports = __webpack_public_path__ + "static/media/bi_clock.9bbe45af.png";